import React from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
} from "reactstrap"
import Header from "../../components/External/Header"
import Footer from "../../components/External/Footer"
import heroImage from "../../assets/images/recruitment.jpeg"
import feature1 from "../../assets/images/permanent.jpeg"
import feature2 from "../../assets/images/temporary.jpeg"
import feature3 from "../../assets/images/executive.jpeg"
import "./Recruitment.css"
import ContactUs from "./ContactUs"
import BookADemo from "./BookADemo"

const Recruitment = () => {
              const BookADemo = () => {
                location.href = "/book"
              }

              const ContactUs = () => {
                location.href = "/contactus"
              }
  return (
    <>
      <Header />

      <div className="page-content">
        {/* Hero Section */}
        <section
          className="hero-section text-white text-center py-5"
          style={{
            backgroundImage: `url(${heroImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Container>
            <h1 className="display-4">Recruitment Made Easy</h1>
            <p className="lead">
              Connecting top talent with the right opportunities for mutual
              growth and success.
            </p>
            {/* <Button color="primary" size="lg">
              Learn More
            </Button> */}
          </Container>
        </section>

        {/* Features Section */}
        <section className="features-section my-5">
          <Container>
            <h2 className="text-center mb-4">Our Recruitment Services</h2>
            <Row>
              <Col md="4" className="mb-4">
                <Card className="h-100 shadow border-0">
                  <img
                    src={feature1}
                    alt="Feature 1"
                    className="card-img-top"
                  />
                  <CardBody>
                    <CardTitle tag="h5">Permanent Recruitment</CardTitle>
                    <CardText>
                      Helping you find the perfect long-term candidates to fit
                      your organization’s needs.
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4" className="mb-4">
                <Card className="h-100 shadow border-0">
                  <img
                    src={feature2}
                    alt="Feature 2"
                    className="card-img-top"
                  />
                  <CardBody>
                    <CardTitle tag="h5">Temporary Staffing</CardTitle>
                    <CardText>
                      Quickly fill short-term positions with qualified and
                      reliable professionals.
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4" className="mb-4">
                <Card className="h-100 shadow border-0">
                  <img
                    src={feature3}
                    alt="Feature 3"
                    className="card-img-top"
                  />
                  <CardBody>
                    <CardTitle tag="h5">Executive Search</CardTitle>
                    <CardText>
                      Specialized services to recruit top-tier executives and
                      leadership roles.
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section bg-light py-5">
          <Container>
            <h2 className="text-center mb-4">Why Choose Us?</h2>
            <Row>
              <Col md="6" className="mb-4">
                <h5>Comprehensive Screening</h5>
                <p>
                  We ensure every candidate is thoroughly vetted to meet your
                  specific requirements.
                </p>
              </Col>
              <Col md="6" className="mb-4">
                <h5>Industry Expertise</h5>
                <p>
                  Our recruitment specialists have deep insights into various
                  industries, ensuring the perfect match.
                </p>
              </Col>
              <Col md="6" className="mb-4">
                <h5>Quick Turnaround</h5>
                <p>
                  Save time and resources by leveraging our efficient
                  recruitment process.
                </p>
              </Col>
              <Col md="6" className="mb-4">
                <h5>Tailored Solutions</h5>
                <p>
                  Customized recruitment strategies designed to align with your
                  organization’s goals.
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section my-5">
          <Container>
            <h2 className="text-center mb-4">What Our Clients Say</h2>
            <Row>
              <Col md="6" className="mb-4">
                <Card className="shadow border-0">
                  <CardBody>
                    <CardText>
                      "Care-Tip’s recruitment services are unmatched. We’ve
                      onboarded exceptional candidates thanks to their efforts."
                    </CardText>
                    <p className="text-muted text-end">- Anna K., HR Manager</p>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" className="mb-4">
                <Card className="shadow border-0">
                  <CardBody>
                    <CardText>
                      "Their executive search expertise helped us find the ideal
                      leader for our team. Highly recommended!"
                    </CardText>
                    <p className="text-muted text-end">- Mark T., CEO</p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Call-to-Action */}
        <section className="cta-section text-center py-5">
          <Container>
            <h2 className="mb-4">Ready to Find Your Next Great Hire?</h2>
            <p className="lead mb-4">
              Contact us today to learn more about our recruitment solutions.
            </p>
            <Button color="primary" size="lg" className="me-3" onClick={ContactUs}>
              Contact Us
            </Button>
            <Button color="secondary" size="lg" onClick={BookADemo}>
              Learn More
            </Button>
          </Container>
        </section>
      </div>

      <Footer />
    </>
  )
}

export default Recruitment
